import { useState } from 'preact/hooks'
import { KartenMarkdown } from '../lib/markdown.jsx'

/**
 * Multiple-Choice-Karte. Ablauf unverändert aus der YouTube-App
 * (app.js, fcRenderMcCard mit continueAfterAnswer):
 *
 *   Auswahl → sperren, richtige markieren, Erklärung zeigen
 *          → „Weiter" → sendet good (richtig) bzw. again (falsch)
 *
 * Es gibt hier bewusst keine vier Bewertungsknöpfe: die Bewertung ergibt sich
 * aus der Auswahl. Der Server bestraft `again` auf MC-Karten zusätzlich mit
 * mc_wrong_streak.
 */
export function McKarte({ karte, aufWeiter }) {
  const [gewaehlt, setGewaehlt] = useState(null)
  const beantwortet = gewaehlt !== null
  const richtig = beantwortet ? !!karte.options[gewaehlt]?.correct : false

  function klasseFuer(option, index) {
    const klassen = ['mc-option']
    if (!beantwortet) return klassen.join(' ')
    klassen.push('mc-option--gesperrt')
    if (option.correct) klassen.push('mc-option--richtig')
    else if (index === gewaehlt) klassen.push('mc-option--falsch')
    else klassen.push('mc-option--gedaempft')
    return klassen.join(' ')
  }

  return (
    <div class="mc">
      <KartenMarkdown class="kartentext__frage" text={karte.front_md} />

      <ul class="mc__optionen">
        {karte.options.map((option, index) => (
          <li key={`${option.text}-${index}`}>
            <button
              type="button"
              class={klasseFuer(option, index)}
              disabled={beantwortet}
              // Das disabled-Attribut allein reicht nicht: programmatisch
              // zugestellte Klicks erreichen gesperrte Knöpfe trotzdem.
              onClick={() => {
                if (beantwortet) return
                setGewaehlt(index)
              }}
            >
              {option.text}
            </button>
          </li>
        ))}
      </ul>

      {beantwortet ? (
        <div class="mc__aufloesung">
          <p class={`mc__ergebnis ${richtig ? 'mc__ergebnis--richtig' : 'mc__ergebnis--falsch'}`}>
            {richtig ? 'Richtig' : 'Falsch'}
          </p>
          {karte.back_extra_md ? (
            <KartenMarkdown class="kartentext__zusatz" text={karte.back_extra_md} />
          ) : null}
          <button
            type="button"
            class="knopf knopf--haupt"
            onClick={() => aufWeiter(richtig ? 'good' : 'again')}
          >
            Weiter
          </button>
        </div>
      ) : null}
    </div>
  )
}
